export enum PathMap {
  // Auth
  AuthAdmin = '',
  Login = 'login',
  SignUp = 'sign-up',
  ForgotPassword = 'forgot-password',
  ForgotPasswordEmailSent = 'forgot-password-email-sent',
  PasswordReset = 'password-reset',
  PasswordResetSucceeded = 'password-reset-succeeded',
  PasswordResetFailed = 'password-reset-failed',

  // Public Home
  Home = '',

  // App
  App = 'app',
  AppHome = 'home',
  Administracion = 'administracion',
  AdministracionParametros = 'parametros',
  AdministracionClientes = 'clientes',
  ConformarGrupos = 'conformar-grupos',
  AdministracionGrupos = 'grupos',
  AdministracionUsuarios = 'usuarios',

  // Auth-App
  Auth = 'auth-app',
}
